import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "pro"
const ProIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M16.962 9.358C18.65 9.358 19.704 10.461 19.704 12.226V12.234C19.704 14.003 18.654 15.106 16.962 15.106 15.278 15.106 14.225 14.003 14.224 12.234V12.226C14.224 10.461 15.286 9.358 16.962 9.358M16.962 10.528C16.174 10.527 15.662 11.172 15.662 12.225V12.234C15.662 13.288 16.17 13.937 16.962 13.937 17.77 13.937 18.27 13.277 18.27 12.234V12.226C18.27 11.176 17.758 10.527 16.962 10.527M6.814 9.458C8.052 9.458 8.852 10.235 8.852 11.423V11.43C8.852 12.618 8.052 13.38 6.814 13.38H5.86V15.007H4.45V9.457zM5.86 12.318H6.475C7.071 12.319 7.425 12.008 7.425 11.43V11.423C7.425 10.846 7.071 10.538 6.475 10.538H5.86zM11.725 9.458C13.067 9.458 13.824 10.123 13.824 11.3V11.307C13.824 12.018 13.454 12.634 12.878 12.884L13.99 15.007H12.405L11.451 13.096H10.732V15.006H9.322V9.459zM10.732 12.072H11.567C12.067 12.073 12.386 11.772 12.386 11.305V11.296C12.386 10.831 12.056 10.523 11.559 10.523H10.732z"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M21.155 1.508C21.911 1.585 22.5 2.223 22.5 3V21C22.5 21.828 21.828 22.5 21 22.5H3C2.172 22.5 1.5 21.828 1.5 21V3C1.5 2.172 2.17 1.5 2.998 1.5H21.002zM3 21H21V3H3z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default ProIcon
